import { useEffect } from 'react';
import { useDispatch, useStore } from 'react-redux'

import {
  resetGlobalQuotationVehicle,
  resetGlobalQuotationTaker,
  resetGlobalQuotationQuotation,
  resetGlobalQuotationGlobals,
} from 'Redux/actions/globalQuotation';

import { resetGlobalComparationQuotation } from 'Redux/actions/comparationQuotationActions';


const useGlobalQuotationProccessHandler = ({ resetReducersOnMounth }) => {
  const dispatch = useDispatch();
  const store = useStore();

  const resetReducers = () => {
    resetGlobalQuotationVehicle()(dispatch, store.getState);
    resetGlobalQuotationTaker()(dispatch, store.getState);
    resetGlobalQuotationQuotation()(dispatch, store.getState);
    resetGlobalQuotationGlobals()(dispatch, store.getState);
    resetGlobalComparationQuotation()(dispatch, store.getState);
  };

  useEffect(() => {
    if (resetReducersOnMounth) resetReducers();
  }, []);

  return {
    resetReducers,
  };
};

export default useGlobalQuotationProccessHandler;
